var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShow ? _c('SidebarSection', {
    attrs: {
      "width": "60%",
      "disabledAction": true,
      "title": "ar_client_detail_travelagent",
      "isShow": _vm.isShow
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShow = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', {
    staticClass: "content-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_general_information")) + " ")])])], 1), _c('GeneralInfo', {
    attrs: {
      "leftWidth": "100px",
      "rightWidth": "90px",
      "list": _vm.listGeneral
    }
  })], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }